import { useEffect, useRef, useState } from "react";

export default function PhilosophySection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 md:py-40 bg-secondary/50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          <div
            className={`order-2 lg:order-1 transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            
            <div className="aspect-[3/4] overflow-hidden">
              <img src="https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/46696d103_ChatGPT_Image_9_mai_2026__14_31_01.png"

              alt="LYKKE design philosophy winter" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1.5s]" />

              
            </div>
          </div>

          <div className={`order-1 lg:order-2 transition-all duration-1000 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="text-sm tracking-widest-2xl font-body uppercase text-primary mb-6">
              Vår Designfilosofi
            </p>
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light leading-[1.1] mb-8 text-[#2a1810]">
              Riktige proporsjoner.
              <br />
              <span className="italic">Bedre löyly.</span>
            </h2>
            <div className="w-12 h-px bg-primary/40 mb-8" />
            <p className="text-foreground/70 mb-6 text-2xl font-body leading-relaxed max-w-lg">En god badstue handler ikke bare om materialer og design. Det viktigste er følelsen av god löyly og at rommet har riktige proporsjoner. Høyden under taket, plasseringen av benkene og avstanden til ovnen har mye å si for hvordan varmen føles i hele badstuen.

            </p>
            <p className="text-foreground/70 font-body leading-relaxed max-w-lg" style={{ fontSize: "23px" }}>Derfor bygger vi etter tradisjonelle finske prinsipper, slik at varmen blir jevn, behagelig og fungerer slik en god badstue faktisk skal.

            </p>

            <blockquote className="mt-10 pl-6 border-l-2 border-primary/30">
              

              
            </blockquote>
          </div>
        </div>
      </div>
    </section>);

}